<template>
  <AdminBackground>
    <div class="image-wrapper">
      <img
        src="@/assets/header/KUMBAHAN BUKAN NAJIS.png"
        alt="KUMBAHAN BUKAN NAJIS"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            label="Tahun"
            :items="items"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            label="Negeri"
            :items="negeri"
            placeholder="Semua Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Semua PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
          />
        </div>
      </div>
    </div>
    <PrimaryModule />
    <KejuruteraanKesihatanMenu />  
  </adminbackground>
</template>


<script setup>
const items = [
  '2021',
  '2022',
  '2023',
  '2024',
]

const negeri = [
  'California',
  'Colorado',
  'Florida',
  'Georgia',
  'Texas',
  'Wyoming',
]

const pbt = [
  'California',
  'Colorado',
  'Florida',
  'Georgia',
  'Texas',
  'Wyoming',
]

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  border-radius: 20px; /* Rounded corners */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; /* Adjusted size */
  height: auto;
}

.line-under-image {
  width: 70%; /* Match width to the image size */
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}


/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}


.main-image-container {
  position: relative;
  display: inline-block;
}

.main-number-overlay {
  position: absolute;
  top: 85%; /* Adjusted to position number closer to the bottom */
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3rem;
  font-weight: bold;
  color: #a80000;
  padding: 10px 20px;
  border-radius: 5px;
}

.tandas {
  display: grid;
  grid-template-columns: 1fr 1fr; 
  grid-gap: 10px; /* Reduced gap between the main and star rating images */
  margin-top: 10px; /* Adjusted margin for smaller space between main and tandas sections */
}

.tandas-container {
  position: relative;
  width: 100%;
  max-width: 450px; /* Adjust the size to fit 2 columns */
  margin: 0 auto;
  border-radius: 10px;
  overflow: hidden;
}

.tandas-container img {
  border-radius: 10px; /* Optional: Add rounded corners */
}

.number-overlay {
  position: absolute;
  top: 50%;
  left: 90%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
  font-weight: bold;
  color: #a80000;
  padding: 10px;
  border-radius: 5px;
}

/* Responsive styles */
@media (max-width: 768px) {
  h2 {
    font-size: 24px;
  }

  .content-wrapper {
    padding: 15px;
  }

  .tandas {
    grid-template-columns: 1fr; /* Stack images in one column on smaller screens */
  }
}

/* Additional styles for very small mobile screens */
@media (max-width: 480px) {
  h2 {
    font-size: 20px;
  }
}
</style>
